module.exports = __webpack_public_path__ + "static/media/ActivityTableStep3.c69d3bcb.png";